import { render, staticRenderFns } from "./drop-area.vue?vue&type=template&id=0de8d7bd"
import script from "./drop-area.vue?vue&type=script&lang=js"
export * from "./drop-area.vue?vue&type=script&lang=js"
import style0 from "./drop-area.vue?vue&type=style&index=0&id=0de8d7bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports